import { Component, OnInit } from '@angular/core';
import { ValueService } from 'src/app/services/value.service';

@Component({
  selector: 'app-layout-page',
  templateUrl: './layout-page.component.html',
  styleUrls: ['./layout-page.component.css']
})
export class LayoutPageComponent implements OnInit {

  constructor(private getdata:ValueService) { }

  ngOnInit(): void {
    document.getElementById('css').setAttribute('href', 'assets/css/style.css');
    this.getdata.isVisibleSource.next(true);
  }

}
